import $ from 'jquery';
import View from 'view/base';

export default View.extend({
    className: 'survey-question-select',

    events: {
        'click div': 'onClickOpen'
    },

    dom_handlers: {
        onClickOpen: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var question_type = $(e.currentTarget).data('val');
            var question_sub_type = $(e.currentTarget).data('sub-type');

            if (this.mode === 'add') {
                this.trigger('Question:Add', question_type, question_sub_type);
            } else {
                this.trigger('Question:Change', question_type, question_sub_type);
            }
        }
    },

    initialize: function(options) {
        this.mode = options.mode;

        this.listenTo(this.collection, 'add', this.render);
        this.listenTo(this.collection, 'reset', this.render);
        this.listenTo(this.collection, 'remove', this.render);
    },

    render: function() {
        var welcome_page = this.collection.findWhere({question_type: 'welcome'});

        var content = this.mode === 'add' ?
        '<div data-type="intro" class="stop-propagation">Intro</div>' +
        '<div data-val="welcome" ' + (welcome_page ? 'class="disabled"' : '') + '>Intro</div>' +
        '<hr class="small">' : '';

        content +=
        '<div data-type="open" class="stop-propagation">Open Questions</div>' +
        '<div data-val="short">Short Answer</div>' +
        '<div data-val="long">Long Answer</div>' +

        '<div data-type="selection" class="stop-propagation"">Selection</div>' +
        '<div data-val="yesno">Yes or No</div>' +
        '<div data-val="multiple">Multiple Choice</div>' +
        '<div data-val="dropdown">Dropdown</div>' +

        '<div data-type="rating" class="stop-propagation">Rating Scale</div>' +
        '<div data-val="rating" data-sub-type="thumb">Thumbs</div>' +
        '<div data-val="rating" data-sub-type="face">Faces</div>' +
        '<div data-val="rating" data-sub-type="star">Stars</div>' +
        '<div data-val="rating" data-sub-type="heart">Hearts</div>' +
        '<div data-val="rating" data-sub-type="number">Numbers</div>' +
        '<div data-val="nps">Net Promoter Score&#174;</div>';

        this.$el.html(content);

        this.$el.toggleClass('question-select-change', this.mode === 'change');

        return this;
    }
});
